<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <strong class="hide-name">{{currentUserBind.account}}</strong>
      <img
        :src="currentUserBind.infoAccount.anh_dai_dien ? currentUserBind.infoAccount.anh_dai_dien : 'img/user.png'"
        class="img-avatar"
      />
    </template>
    <template slot="dropdown">
      <b-card :no-body="true" footer-class="px-3 py-2" class="mb-0 header-card-account">
        <b-card-body class="p-3 clearfix">
          <!-- <i class="icon-user bg-primary p-3 font-2xl mr-3 float-left"></i> -->
          <div class="mr-3 float-left">
            <img
              :src="currentUserBind.infoAccount.anh_dai_dien ? currentUserBind.infoAccount.anh_dai_dien : 'img/user.png'"
              class="img-avatar"
              width="50"
            />
          </div>
          <div></div>
          <div class="h6 text-info mb-0 mt-2 mb-1">{{currentUserBind.infoAccount.name}}</div>
          <div
            class="font-xs text-muted text-uppercase bold-500"
          >{{currentUserBind.infoAccount.position}}</div>
        </b-card-body>
        <div slot="footer" v-if="!mData.hideProfileLink">
          <b-link
            class="font-weight-bold font-xs btn-block text-muted"
            @click="fn_gottoInFoAccount()"
          >
            {{aLang.header_gotoUserProfile}}
            <i class="fa fa-angle-right float-right font-lg"></i>
          </b-link>
        </div>
      </b-card>

      <!-- <b-dropdown-header tag="div" class="text-center">
        <strong>{{currentUser.infoAccount.name}} - {{currentUser.infoAccount.position}}</strong>
      </b-dropdown-header>-->

      <!-- Hiển thị thông báo -->
      <!-- <b-dropdown-item>
        <i class="fa fa-bell-o" /> Thông báo
        <b-badge variant="info">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-envelope-o" /> Tin nhắn
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-tasks" /> Công việc
        <b-badge variant="danger">{{ itemsCount }}</b-badge>
      </b-dropdown-item>-->

      <!-- <b-dropdown-item><i class="fa fa-comments" /> Comments
        <b-badge variant="warning">{{ itemsCount }}</b-badge>
      </b-dropdown-item>-->
      <!-- <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item><i class="fa fa-user" /> Profile</b-dropdown-item>
      <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item>
      <b-dropdown-item><i class="fa fa-usd" /> Payments
        <b-badge variant="secondary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-file" /> Projects
        <b-badge variant="primary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>-->
      <!-- <b-dropdown-divider /> -->
      <!-- <b-dropdown-item>
        <i class="fa fa-shield" /> Lock Account
      </b-dropdown-item>-->
      <b-dropdown-item router-link to="/auth/changepassword">
        <i class="icon-key" />
        {{aLang.header_goChangePassword}}
      </b-dropdown-item>
      <b-dropdown-item @click="fn_logout()">
        <i class="icon-logout" />
        {{aLang.logout}}
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";

import AuthService from "../service/AuthService";
import LanguageService from "../service/LanguageService";
import ProfileApi from "../moduleApi/ProfileApi";
import DiemDenAnToanApi from "../moduleApi/DiemDenAnToanApi";
import MethodService from "../service/MethodService";
import ExtensionService from "../service/ExtensionService";

// danh sách các quyền không được sửa profile
const disabledUpdateProfileRoles = ['TourAgent'];

export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      aLang: LanguageService.lang,
      itemsCount: 0,
      currentUser: {},
      currentUserBind: {
        account: "",
        infoAccount: {}
      },
      mData: {
        hideProfileLink: false
      }
    };
  },
  methods: {
    fn_logout() {
      this.$confirm(LanguageService.lang.logout, {
        confirmButtonText: LanguageService.lang.c_yes,
        cancelButtonText: LanguageService.lang.c_no,
        type: "info"
      })
        .then(() => {
          AuthService.logout(false)
            .then(res => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_success,
                type: "success"
              });
              this.$router.push({ name: "Auth-Login" });
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_error,
                type: "error"
              });
            });
        })
        .catch();
    },
    fn_setRole() {
      if (this.currentUser.roles.indexOf("BuiltinAdmin") != -1) {
        this.currentUser.infoAccount.position = "Quản trị hệ thống (BuiltinAdmin)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Super admin";
      }
      if (this.currentUser.roles.indexOf("Admin") != -1) {
        this.currentUser.infoAccount.position = "Quản trị hệ thống (Admin)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Admin";
      }
      if (this.currentUser.roles.indexOf("Officer") != -1) {
        this.currentUser.infoAccount.position = "Cơ quan quản lý (Officer)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Officer";
      }
      if (this.currentUser.roles.indexOf("TourAgent") != -1) {
        this.currentUser.infoAccount.position = "Công ty lữ hành (TourAgent)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "TourAgent";
      }
      if (this.currentUser.roles.indexOf("TourGuide") != -1) {
        this.currentUser.infoAccount.position = "Hướng dẫn viên du lịch (TourGuide)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "TourGuide";
      }
      if (this.currentUser.roles.indexOf("HqsManager") != -1) {
        this.currentUser.infoAccount.position = "Duyệt dịch vụ du lịch clc (HqsManager)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "HqsManager";
      }
      if (this.currentUser.roles.indexOf("HqsContributor") != -1) {
        this.currentUser.infoAccount.position = "Đăng dịch vụ du lịch clc (HqsContributor)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "HqsContributor";
      }

      this.currentUser.infoAccount.nam = 123;


    },
    async fn_getAccount() {
      this.currentUser = MethodService.getCurrentUser();
      this.currentUser.infoAccount = {
        anh_dai_dien: "",
        email: "",
        name: "",
        phoneNumber: "",
        position: ""
      };
      console.log("Thông tin người dùng");
      console.log(this.currentUser);

      try{
        let res = await ProfileApi.findByIdRootScope(this.currentUser.id)

        if (res.result) {
          this.currentUser.infoAccount = res.result;
          this.currentUser.infoAccount.name = res.result.ho_ten.ho_ten;
          if (res.result.avatar_id) {
            this.currentUser.infoAccount.anh_dai_dien = ExtensionService.urlImg + res.result.avatar_id + "&r=square&w=512";
            console.log("anh_dai_dien", this.currentUser.infoAccount.anh_dai_dien);
          }
        }
      }
      catch (error) {
        console.error(error);
      }
      finally {
        this.fn_setRole();
      }

      if (this.currentUser.roles && this.currentUser.roles.indexOf("SafePlace") !== -1) {
        try{
          let res = await DiemDenAnToanApi.list({filters: 'nguoi_tao_id=' + this.currentUser.id, fields: "hoat_dong,loai_diem_den,thong_tin_chung.anh"});
          if (res.result && res.result.length > 0) {
            console.log("res.result",res.result);
            if (res.result[0].thong_tin_chung && res.result[0].thong_tin_chung.anh) {
              this.currentUser.infoAccount.anh_dai_dien = ExtensionService.urlSurveyImg + res.result[0].thong_tin_chung.anh + "&r=square&w=512";
              console.log("anh_dai_dien (survey)", this.currentUser.infoAccount.anh_dai_dien);
            }
            if(res.result[0].hoat_dong && res.result[0].hoat_dong.ngung_hoat_dong == true){
              if (
                window.location.pathname == "/admin/CheckinDDAT/list" ||
                window.location.pathname == "//admin/home"
              ) {
                this.$router.push({name: "Admin-DangKyDDAT-list"});
              }
            }
          }
        }catch(error){
          console.error(error);
        }
      }

      this.mData.hideProfileLink = this.currentUser.roles && this.currentUser.roles.some(role => disabledUpdateProfileRoles.includes(role));

      this.currentUserBind = this.currentUser;
    },
    fn_gottoInFoAccount() {
      this.$router.push({
        name: "Admin-NguoiDung-update",
        params: { id: this.currentUserBind.id }
      });
    }
  },
  created() {

  },
  mounted() {
    this.fn_getAccount();
  }
};
</script>
<style>
  @media screen and (max-width: 576px) {
    .el-message-box {
      width: 90%;
    }
  }
  @media (max-width: 415px) {
    .hide-name {
      display: none;
    }
  }
</style>
